import { FunctionComponent } from "react";
import ForgotPasswordForm from "src/components/forms/auth/ForgotPasswordForm";
import { PageContainer, PageTitle } from "src/components/generic";
import TopNav from "src/components/navigation/TopNav";

const ForgotPassword: FunctionComponent = () => (
    <PageContainer>
        <div className="px-3">
            <TopNav />
        </div>
        <div>
            <PageTitle title="Forgot Password" />

            <ForgotPasswordForm />
        </div>
    </PageContainer>
);

export default ForgotPassword;